import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import SeriesFareTabs from "./SeriesFareTabs"; // Import the new tabs component
import "./SeriesFareDashboard.css";

const SeriesFareDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState([]);
  const [recentFares, setRecentFares] = useState([]);
  const [loading, setLoading] = useState(true);

  // Dashboard statistics
  const dashboardStats = [
    { title: "Active Fares", value: "128", icon: "💰", color: "seriesfare-stat-blue", change: "+12%" },
    { title: "Total Airlines", value: "42", icon: "✈️", color: "seriesfare-stat-green", change: "+5%" },
    { title: "Destinations", value: "56", icon: "🌍", color: "seriesfare-stat-purple", change: "+8%" },
    { title: "Revenue", value: "INR 2.4Cr", icon: "📈", color: "seriesfare-stat-pink", change: "+15%" },
    { title: "Seats Available", value: "2,845", icon: "🪑", color: "seriesfare-stat-cyan", change: "-3%" },
    { title: "Expiring Soon", value: "24", icon: "⏰", color: "seriesfare-stat-amber", change: "+18%" },
  ];

  // Sample recent fares data
  const sampleFares = [
    { id: "SF-001", airline: "AI", from: "DEL", to: "BOM", class: "Economy", departure: "15 Dec 2023", seats: 45, price: "INR4,299" },
    { id: "SF-002", airline: "6E", from: "BLR", to: "MAA", class: "Business", departure: "18 Dec 2023", seats: 12, price: "INR8,499" },
    { id: "SF-003", airline: "SG", from: "HYD", to: "CCU", class: "Economy", departure: "20 Dec 2023", seats: 28, price: "INR5,799" },
    { id: "SF-004", airline: "UK", from: "MAA", to: "DEL", class: "Premium", departure: "22 Dec 2023", seats: 18, price: "INR6,899" },
    { id: "SF-005", airline: "G8", from: "GOI", to: "PNQ", class: "Economy", departure: "25 Dec 2023", seats: 35, price: "INR3,999" },
  ];

  useEffect(() => {
    // Simulate API call
    setLoading(true);
    setTimeout(() => {
      setStats(dashboardStats);
      setRecentFares(sampleFares);
      setLoading(false);
    }, 500);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                {/* <SeriesFareTabs pageName="SERIESFAREDASHBOARD" /> */}
              </div>
              <div className="card-body">
 <div className="seriesfaredashboard-dashboard">
                 <main className="seriesfaredashboard-main-content-fullscreen">
                    {/* Header */}
                    <header className="seriesfaredashboard-main-header">
                      <div className="seriesfaredashboard-header-content">
                        <div className="seriesfaredashboard-header-title">
                          <h1>Series Fare Dashboard</h1>
                          <p>Manage series fares, routes, and requests</p>
                        </div>

                       
                      </div>
                    </header>
                {/* Stats Grid */}
                <div className="seriesfare-stats-grid mb-4">
                  {stats.map((stat, index) => (
                    <div key={index} className={`seriesfare-stat-card ${stat.color}`}>
                      <div className="seriesfare-stat-icon-container">{stat.icon}</div>
                      <div className="seriesfare-stat-value">{stat.value}</div>
                      <div className="seriesfare-stat-title">{stat.title}</div>
                      <div className={`seriesfare-stat-change ${stat.change.startsWith('+') ? 'positive' : 'negative'}`}>
                        {stat.change}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Main Content Grid */}
                <div className="seriesfare-content-grid">
                  {/* Recent Fares Table */}
                  <div className="seriesfare-main-card">
                    <div className="seriesfare-card-header">
                      <div className="seriesfare-card-title">
                        <div className="seriesfare-card-icon seriesfare-fares-icon">
                          📋
                        </div>
                        <div>
                          <h3>Recent Series Fares</h3>
                          <p>Latest created fare entries</p>
                        </div>
                      </div>
                      <button 
                        className="seriesfare-view-all-btn"
                        onClick={() => handleNavigation('/seriesfare/list')}
                      >
                        View All →
                      </button>
                    </div>
                    
                    <div className="seriesfare-requests-table">
                      <table className="seriesfare-table">
                        <thead>
                          <tr>
                            <th>Fare ID</th>
                            <th>Airline</th>
                            <th>Route</th>
                            <th>Class</th>
                            <th>Departure</th>
                            <th>Seats</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {recentFares.map((fare, index) => (
                            <tr key={index} className="seriesfare-table-row">
                              <td>
                                <div className="seriesfare-request-id">
                                  <span className="seriesfare-id-badge">{fare.id}</span>
                                </div>
                              </td>
                              <td>
                                <div className="seriesfare-applicant-info">
                                  <div className="seriesfare-applicant-name">{fare.airline}</div>
                                </div>
                              </td>
                              <td>
                                <div className="seriesfare-type-info">
                                  <div className="seriesfare-type-label">{fare.from} → {fare.to}</div>
                                </div>
                              </td>
                              <td>
                                <span className="seriesfare-status-badge seriesfare-status-active">
                                  {fare.class}
                                </span>
                              </td>
                              <td>
                                <div className="seriesfare-appointment-info">
                                  <div className="seriesfare-appointment-date">{fare.departure}</div>
                                </div>
                              </td>
                              <td>
                                <div className="seriesfare-documents-count">
                                  <span>{fare.seats}</span>
                                </div>
                              </td>
                              <td>
                                <div className="seriesfare-fee-amount">{fare.price}</div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Sidebar Cards */}
                  <div className="seriesfare-sidebar-cards">
                    {/* Quick Actions Card */}
                    <div className="seriesfare-card mb-3">
                      <div className="seriesfare-card-header">
                        <div className="seriesfare-card-title">
                          <div className="seriesfare-card-icon seriesfare-quick-icon">
                            ⚡
                          </div>
                          <div>
                            <h3>Quick Actions</h3>
                            <p>Common tasks</p>
                          </div>
                        </div>
                      </div>
                      
                      <div className="seriesfare-quick-actions-list">
                        <button 
                          className="seriesfare-quick-action-btn"
                          onClick={() => handleNavigation('/seriesfare/create')}
                        >
                          <div className="seriesfare-quick-action-icon">➕</div>
                          <div>Create New Fare</div>
                        </button>
                        <button 
                          className="seriesfare-quick-action-btn"
                          onClick={() => handleNavigation('/seriesfare/list')}
                        >
                          <div className="seriesfare-quick-action-icon">📋</div>
                          <div>Manage Fares</div>
                        </button>
                        <button 
                          className="seriesfare-quick-action-btn"
                          onClick={() => handleNavigation('/seriesfare/airlines')}
                        >
                          <div className="seriesfare-quick-action-icon">✈️</div>
                          <div>Airlines</div>
                        </button>
                        <button 
                          className="seriesfare-quick-action-btn"
                          onClick={() => handleNavigation('/seriesfare/reports')}
                        >
                          <div className="seriesfare-quick-action-icon">📊</div>
                          <div>Generate Report</div>
                        </button>
                      </div>
                    </div>

                    {/* Summary Card */}
                    <div className="seriesfare-card">
                      <div className="seriesfare-card-header">
                        <div className="seriesfare-card-title">
                          <div className="seriesfare-card-icon seriesfare-summary-icon">
                            📈
                          </div>
                          <div>
                            <h3>Summary</h3>
                            <p>This month's performance</p>
                          </div>
                        </div>
                      </div>
                      
                      <div className="seriesfare-summary-stats">
                        <div className="seriesfare-summary-item">
                          <span className="seriesfare-summary-label">Fares Created</span>
                          <span className="seriesfare-summary-value">24</span>
                        </div>
                        <div className="seriesfare-summary-item">
                          <span className="seriesfare-summary-label">Revenue</span>
                          <span className="seriesfare-summary-value">INR48.2L</span>
                        </div>
                        <div className="seriesfare-summary-item">
                          <span className="seriesfare-summary-label">Avg. Fare</span>
                          <span className="seriesfare-summary-value">INR2,010</span>
                        </div>
                        <div className="seriesfare-summary-item">
                          <span className="seriesfare-summary-label">Seats Sold</span>
                          <span className="seriesfare-summary-value">1,248</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                 </main>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeriesFareDashboard;